"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobx_react_1 = require("mobx-react");

var react_1 = __importStar(require("react"));

var ca_ui_toolkit_1 = require("ca-ui-toolkit");

var StringResources_1 = __importDefault(require("../../nls/StringResources"));

var ValueInput_1 = __importDefault(require("../valueInput/ValueInput"));
/** Pair of inputs for a condition and its values **/


var ConditionComponent =
/** @class */
function (_super) {
  __extends(ConditionComponent, _super);

  function ConditionComponent(props) {
    var _this = _super.call(this, props) || this;

    _this.nodeRef = react_1.default.createRef();
    return _this;
  }

  ConditionComponent.prototype.componentDidUpdate = function () {
    if (this.nodeRef.current) {
      var options = this.props.options;

      var selectedValue = this._getSelectedValue();

      var state = {
        currentValues: options,
        inputValue: selectedValue ? selectedValue['label'] : ''
      };
      this.nodeRef.current.setState(state);
    }
  };

  ConditionComponent.prototype.render = function () {
    var _a = this.props,
        classPrefix = _a.classPrefix,
        options = _a.options,
        valueOnChange = _a.valueOnChange,
        onTypeChange = _a.onTypeChange,
        value = _a.value,
        _b = _a.type,
        type = _b === void 0 ? null : _b,
        scale = _a.scale,
        uiContext = _a.uiContext;
    return react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'column'
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: ca_ui_toolkit_1.classnames("vis-cf-" + classPrefix + "-value-combobox")
    }, react_1.default.createElement(ca_ui_toolkit_1.ComboBox, {
      ref: this.nodeRef,
      type: 'text',
      startingValues: options,
      selectedValue: this._getSelectedValue(),
      placeholder: StringResources_1.default.get('conditionalFormattingSelectRule'),
      customWidth: '100%',
      onChange: function onChange(selectedType) {
        if (selectedType.value !== type) {
          onTypeChange(selectedType.value);
        }
      }
    })), react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: ca_ui_toolkit_1.classnames("vis-cf-" + classPrefix + "-value-numberinput")
    }, react_1.default.createElement(ValueInput_1.default, {
      scale: scale,
      value: value,
      valueOnChange: valueOnChange,
      uiContext: uiContext,
      type: type
    })));
  };

  ConditionComponent.prototype._getSelectedValue = function () {
    var type;
    var _a = this.props,
        options = _a.options,
        currentType = _a.type;

    if (currentType && currentType.length) {
      var availableOptions = options.map(function (option) {
        return option.value;
      });
      type = availableOptions.includes(currentType) ? currentType : null;
    }

    return type ? {
      value: type,
      label: type ? StringResources_1.default.get("conditionalFormatting" + type) : ''
    } : undefined;
  };

  return ConditionComponent;
}(react_1.Component);

exports.default = mobx_react_1.observer(ConditionComponent);
